import * as $ from 'jquery';

import {
  Inject,
  OnInit,
  Component,
} from 'ng-metadata/core';

import alphabetStripHtml from './alphabet-strip.html';
import './alphabet-strip.scss';



@Component({
  selector: 'gw-directory-alphabet-strip',
  template: alphabetStripHtml,
})
export class AlphabetStripComponent implements OnInit {
  public alphabet = [
    'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I', 'J', 'K',
    'L', 'M', 'N', 'O', 'P', 'Q', 'R', 'S', 'T', 'U', 'V',
    'W', 'X', 'Y', 'Z',
  ];

  constructor(
    @Inject('$location') private $location: ng.ILocationService,
    @Inject('$anchorScroll') private $anchorScroll: ng.IAnchorScrollService,
  ) {}

  ngOnInit() {

  }

  disableLetter(letter: string) {
    const $section = $(`#${letter}`);

    if ($section.length === 0) {
      return true;
    }

    return false;
  }

  scrollTo(letter: string) {
    this.$location.hash(letter);
    this.$anchorScroll();
  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/directory/alphabet-strip/alphabet-strip.component.ts